import { GridSumTable } from '../../UI';
import { useInvestmentDetailsTable, UseInvestmentDetailsTableArgs } from '../hooks';
import { InvestmentSumTableArgs } from '../../Investment';

interface InvestmentDetailsTableProps
  extends UseInvestmentDetailsTableArgs,
    Pick<InvestmentSumTableArgs, 'onClickItem'> {}

export function InvestmentDetailsTable({ ...useInvestmentDetailsTableArgs }: InvestmentDetailsTableProps) {
  const { tUI, isLoading, liquidInvestments, qualifiedInvestments, columns } =
    useInvestmentDetailsTable(useInvestmentDetailsTableArgs);

  return (
    <div className="space-y-6">
      <GridSumTable
        isLoading={isLoading}
        hideOnEmpty
        sum={liquidInvestments.totalInvestmentValue}
        title={tUI('equity-rate-liquid-investments-table-title')}
        sumTitle={tUI('equity-rate-liquid-investments-table-sum-title')}
        sumAppendix={liquidInvestments.monthlyContributionsDisplay}
        rows={liquidInvestments.investments}
        columns={columns}
      />
      <GridSumTable
        isLoading={isLoading}
        hideOnEmpty
        sum={qualifiedInvestments.totalInvestmentValue}
        title={tUI('equity-rate-qualified-investments-table-title')}
        sumTitle={tUI('equity-rate-qualified-investments-table-sum-title')}
        sumAppendix={qualifiedInvestments.monthlyContributionsDisplay}
        rows={qualifiedInvestments.investments}
        columns={columns}
      />
    </div>
  );
}
